import styled from "styled-components";

export const Container = styled.header`
	background-color: #f3faf0;

	.wrapper {
		width: 1440px;
		margin: 0 auto;
		justify-content: space-between;
		display: flex;
		padding: 15px;
	}

	.btns_menu {
		display: flex;
		align-items: center;
		justify-content: center;
		list-style: none;
		width: 100%;

		gap: 20px;

		a {
			color: #020202;
			font-size: 24px;
			padding: 2px 10px;
		}
		a:hover {
			border-bottom: 2px solid var(--main-green);
		}
		#active {
			border-bottom: 2px solid var(--main-green);
			font-weight: bold;
			color: var(--main-green);
		}
	}

	.logo {
		width: 140px;
	}

	.hamMenu {
		display: none;
	}
	.close {
		display: none;
	}

	@media (max-width: 1200px) {
		.wrapper {
			width: 100vw;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
		}
		.btns_menu {
			max-width: calc(100vw);
			width: calc(100vw - 30%);
			gap: 5px;

			a {
				font-size: 18px;
			}
		}

		.logo {
			width: 80px;
		}
	}

	@media (max-width: 795px) {
		.btns_menu {
			display: none;
		}
		.hamMenu {
			display: flex;
			button {
				background: none;
				border: none;
			}
		}

		.wrapper {
			position: relative;
		}

		.mobileMenu {
			position: absolute;
			z-index: 1000;
			background-color: #f3faf0;
			width: 100vw;
			height: 100vh;
			left: 0;
			padding: 10px;
			top: 83px;

			ul {
				display: flex;
				flex-direction: column;
				gap: 5px;
				font-weight: bold;
				li a {
					font-size: 20px;
					color: black;
					text-decoration: none;
				}
			}
		}
	}
`;
